import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputPasswordComponent {
  readonly label: InputSignal<string> = input<string>();
  readonly placeholder: InputSignal<string> = input<string>();
  readonly formControlRef: InputSignal<FormControl> = input<FormControl>();
  readonly required: InputSignal<boolean> = input<boolean>();
  readonly appearance: InputSignal<MatFormFieldAppearance> =
    input<MatFormFieldAppearance>('outline');

  showPassword: boolean = false;
}
